<template>
  <table class="table">
    <thead>
      <tr class="panel-header">
        <th colspan="6" class="panel-header">
          Neuron Population: {{ neuronID }}
          <button class="btn btn-primary btn-sm" v-if="diGraph !== ''" @click.prevent="togglePanel">Visualize</button>
        </th>
      </tr>
    </thead>
    <tbody>
      <NeuronMetaDataPanel :metadata="neuronMetaData" />
      <VizRow :diGraph="diGraph"  :synDiGraph="synapseDiGraph" :visible="graphVisible" />
      <!-- <pre> {{ neuronData }}</pre>  -->
      <LocationHeaderRow />
      <NeuronDataRow v-for="(datum, idx) in neuronData" :key="idx" :datum="datum" />
    </tbody>
  </table>
</template>

<script>
import NeuronDataRow from './NeuronDataRow.vue';
import LocationHeaderRow from "./LocationHeaderRow"
import NeuronMetaDataPanel from './NeuronMetaDataPanel.vue';
import VizRow from './VizRow.vue'

export default {
  props: ['neuronID', 'neuronData'],
  data() {
    return {
      graphVisible: false,
    }
  },
  components: { NeuronDataRow, LocationHeaderRow, NeuronMetaDataPanel, VizRow },

  computed: {
    neuronMetaData() {
      return this.neuronData[0]['neuron_metadata']
    },
    diGraph() {
      return this.neuronData[0]['di_graph']['axonalPath']
    },
    synapseDiGraph() {
        return this.neuronData[0]['di_graph_synapse']['axonalPath']
    }
  },
  methods: {
    togglePanel() {
      this.graphVisible = !this.graphVisible;
    }
  }
}

</script>

<style scoped>
.panel {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: hidden;
}

.panel-header {
  background-color: black;
  color: white;
  text-align: left;
  padding: 10px;
  cursor: pointer;
  border: 1px solid black;
}

.panel-body {
  padding: 10px;
  display: none;
}
</style>